/*
 * The one banner pill group (T176). 🔨 The gap is the banner's own — the same
 * token the title bar spaces its parts with — because the group sits in the
 * banner and nowhere else. 💰 Two stylesheets held this rule with two different
 * gaps, so a document's status pills sat four pixels tighter than a record's for
 * no reason anybody wrote down.
 */
.pills {
  display: inline-flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}
